import FirebaseApp from './firebaseClient';

export default {
  sendFeedback(userId, message) {
    return FirebaseApp.db.collection('appFeedback').add({
      userId,
      message,
      date: FirebaseApp.firebase.firestore.FieldValue.serverTimestamp()
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/appFeedbackApi.js